import {Component, EventEmitter, OnInit} from '@angular/core';
import {CellComponent} from "@shared/components/cell-components/cell-component";
import {InvalidateSubject} from "@shared/helpers/invalidate.subject";
import {FieldDefinition} from "@shared/models/field-definition";

@Component({
    standalone: false,
    selector: 'particle-task-notification-status-cell-viewer',
  templateUrl: './task-notification-status-cell-viewer.component.html',
  styleUrls: ['./task-notification-status-cell-viewer.component.scss']
})
export class TaskNotificationStatusCellViewerComponent implements OnInit, CellComponent {

  sourceType?: string;
  valueChanged?: EventEmitter<any>;
  invalidateSubject?: InvalidateSubject;
  item: any;
  fieldDefinition: FieldDefinition;
  displayText: string;
  statusTooltipKey = 'StatusTooltip';
  status: any;
  disabled: boolean;
  constructor() {
  }

  ngOnInit() {
    this.status = this.fieldDefinition.options.find(item => item.id === this.item.cells[this.fieldDefinition.key].value);
  }
  getStyle() {
    if (this.status === undefined)  {
      return;
    }
    return {
      'background': this.status.tags[0],
      'color': this.status.tags[1]
    }
  }
}
